import { Modal } from "react-bootstrap";
import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

import { BsQuestionLg } from "react-icons/bs";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
export default function ConfirmDialog(props) {
  const handleClose = (value) => {
    props.setShowConfirm(false);
    if (value === true) {
      props.confirmAction.action(props.confirmAction.data);
    }
  };

  return (
    <MyModal show={props.showConfirm} centered>
      <ModalHeaderBlack>การยืนย้น</ModalHeaderBlack>
      <ModalBodyBlack>
        <MsgBox>
          {props.confirmAction && props.confirmAction.title} <BsQuestionLg />
        </MsgBox>
      </ModalBodyBlack>
      <ModalFooterBlack>
        <Button variant="primary" onClick={() => handleClose(true)}>
          ยืนยัน
        </Button>
        <Button variant="danger" onClick={() => handleClose(false)}>
          ยกเลิก
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

const MsgBox = styled.p`
  font-size: large;
  color: #f8f2f2;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const GetConfirmTitle = (type) => {
  switch (type) {
    case "DELETE":
      return "ยืนยันการลบรายการ";
    case "UPDATE":
      return "ยืนยันการแก้ไขรายการ";
    case "ACCEPT_CASE":
      return "ยืนยันการรับเคส";
    case "REJECT_CASE":
      return "ยืนยันการปฏิเสธเคส";
    default:
      return "กรุณายืนยัน";
  }
};
